import React, { useEffect, useRef, useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import './ArtistPostForm.css';

const CREATE_ARTIST_POST = gql`
  mutation CreateArtistPost($input: ArtistPostInput!) {
    CreateArtistPost(input: $input) {
      id
      content
      urlPreview
      images
      artistPageId
      ownerId
    }
  }
`;

const ArtistPostForm = ({ artistPageId, onPostCreated }) => {
  const [content, setContent] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const [facebookShare, setFacebookShare] = useState(false);
  const [error, setError] = useState(null);

  const fileInputRef = useRef(null);

  const token = sessionStorage.getItem('token');

  useEffect(() => {
    if (!imageFile) {
      setImagePreviewUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(imageFile);
    setImagePreviewUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [imageFile]);

  const clearSelectedImage = () => {
    setImageFile(null);
    setImagePreviewUrl(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const [createPost, { loading }] = useMutation(CREATE_ARTIST_POST, {
    context: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    onCompleted: () => {
      setContent('');
      clearSelectedImage();
      setFacebookShare(false);
      setError(null);

      if (onPostCreated) onPostCreated();
    },
    onError: (err) => {
      setError(err.message);
    },
  });

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) {
      clearSelectedImage();
      return;
    }

    setImageFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!artistPageId) {
      setError('Artist page ID missing');
      return;
    }

    const input = {
      content,
      artistPageId: parseInt(artistPageId, 10),
      postToFacebook: facebookShare,
    };

    if (imageFile) {
      input.imageFile = imageFile;
    }

    try {
      await createPost({ variables: { input } });
    } catch (err) {
      console.error('Failed to create post:', err);
    }
  };

  return (
    <div>
      <div className="facebook-unavailable-notice">
        The post to Facebook option isn't available yet.
      </div>

      <div className="post-form-container">
        <form className="post-form" onSubmit={handleSubmit}>
          <textarea
            placeholder="What's on your mind?"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />

          {imagePreviewUrl && (
            <div className="image-preview-wrapper">
              <img
                src={imagePreviewUrl}
                alt="Selected upload preview"
                className="image-preview"
              />

              <button
                type="button"
                className="image-preview-remove"
                onClick={clearSelectedImage}
                aria-label="Remove selected image"
              >
                ×
              </button>
            </div>
          )}

          <div className="form-actions">
            <label className="upload-label">
              📸
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            </label>

            <label className="checkbox">
              <input
                type="checkbox"
                checked={facebookShare}
                onChange={(e) => setFacebookShare(e.target.checked)}
                disabled
              />
              Post to Facebook is not yet available
            </label>

            <button type="submit" disabled={loading}>
              {loading ? 'Posting...' : 'Post'}
            </button>
          </div>

          {error && <div className="post-error">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default ArtistPostForm;